import KeenSlider from 'keen-slider';
import 'particles.js';
import * as THREE from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader';

const http_str = httpUrl;

/**
 * ローディング部分
 */

const worksFetch = async () => {
  const worksListUrl = "https://blog.zaty.jp/wp-json/works/lists?count=-1&pageOff=1";
  return await fetch(worksListUrl)
                .then( res => {
                  if(!window.referrer)
                  {
                    window.loading.pointLoaded();
                  }
                  return res.json();
                });
}
const blogFetch = async () => {
  const blogUrl = 'https://blog.zaty.jp/wp-json/blog/famous';
  return await fetch(blogUrl)
                .then( res => {
                  if(!window.referrer)
                  {
                    window.loading.pointLoaded();
                  }
                  return res.json();
                });
}
const displayLoadFetch = async (loader,templatePath) => {
  return new Promise( res => {
    loader.load( templatePath + '/img/display-mini.glb', obj => {
      if(!window.referrer)
      {
        window.loading.pointLoaded();
      }
      res(obj);
    });
  });
}
const keyboadLoadFetch = async (loader,templatePath) => {
  return new Promise( res => {
    loader.load( templatePath + '/img/keyboad-mini.glb', obj => {
      if(!window.referrer)
      {
        window.loading.pointLoaded();
      }else
      {
        topShortLoad.end();
      }

      res(obj);
    });
  });
}

/**
 * 指定時間後にpromiseを返す
 *
 * @param {int} ms
 */
function sleep(ms) {
  return new Promise(function(resolve) {
    setTimeout(function() {
      resolve();
    }, ms);
  });
}
/**
 * ランダム文字列を生成する
 *
 * @param {int} len 出力するランダム文字列の文字数
 * @return {string}
 */
function getRandumText( len )
{
  const textSource = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!#$%&=~/*-+[{(|^[_??!,.<>])}][{(|^[_??!,.<>])}][{(|^[_??!,.<>])}]";
  let returnText = "";
  for( var i=0; i<len; i++)
  {
    returnText += textSource.charAt( Math.floor( Math.random() * ( textSource.length-1 ) ) );
  }
  return returnText;
}
/**
 * 要素を生成する。
 * @version 1.0.1
 *
 * @param  {String} dom DOMの種類
 * @param  {String} cl [cl=""]  クラス属性
 * @param  {String} inner [inner=""]  innerHTML
 * @param  {Array}  obj [obj=[]] [{key:属性,val:value},{...}]の形式で渡す
 * @param  {HTMLObject} append appendChildする場合は親の要素を指定
 * @return {Object} HTML Elementを返す
 */
const createDom = (dom, cl="",inner="", obj=[],append="") => {
  const returnEl = document.createElement(dom);
  if(cl!=="")
  {
    if (typeof(cl) == "string" || cl instanceof String) {
      returnEl.classList.add(cl);
    } else if (cl instanceof Array) {
      cl.forEach( c => {
        returnEl.classList.add(c);
      });
    }
  }
  if(obj.length)
  {
    obj.forEach((attr, i) => {
      returnEl.setAttribute(attr.key,attr.val);
    });
  }
  if(inner!=="")
  {
    returnEl.innerHTML = inner;
  }
  if(append !== "")
  {
    append.appendChild(returnEl);
  }
  return returnEl;
}

let camera, scene, renderer;
let width = 1000;
let height = 1000 * 288.97/484;
let rotateDeg = Math.PI/180;
let spotLight;
let display, keyboad, topGroup, displayWindow, texture;
let animationLoop=0;

let fps = 120;
let rotateDef = 2;
const frameTime = 1 / fps;
let prevTimestamp = 0;

const setQualityAnimation = (quality = "high") =>{
	switch (quality) {
		case "high":
			fps = 120;
			rotateDef = 3;
			width = 2400;
			height = 2400 * 288.97/484;
			break;
		case "normal":
			fps = 60;
			rotateDef = 3;
			width = 1000;
			height = 1000 * 288.97/484;
			break;
		case "low":
			fps = 30;
			rotateDef = 3;
			width = 300;
			height = 300 * 288.97/484;
			break;
	}
}
const setQualityWidth = ()=>{
	const width = window.innerWidth;
	if(width<500)
	{
		setQualityAnimation("low");
	}else if(width > 1300)
	{
		setQualityAnimation("high");
	}else
	{
		setQualityAnimation("normal");
	}
}
setQualityWidth();

function onResize() {

	camera.aspect = width / height;
	camera.updateProjectionMatrix();

  renderer.setSize( width, height );

	render();

}
let animationFlag = true;
let closeAniFrameId = 0;
function macBookCloseAnimation (timestamp)
{
	const elapsed = (timestamp - prevTimestamp) / 1000;
	if (elapsed <= frameTime) {
		requestAnimationFrame(macBookCloseAnimation);
		return;
	}

	prevTimestamp = timestamp;

	const nowDeg = topGroup.rotation.x;
  if(nowDeg > 91 * rotateDeg)
  {
    topGroup.rotation.x = 91.8 * rotateDeg;
    cancelAnimationFrame(closeAniFrameId);
    animationFlag = true;
  }else
  {
    topGroup.rotation.x += rotateDef * rotateDeg;
    closeAniFrameId = requestAnimationFrame(macBookCloseAnimation);
  }
	render();
}
let openAniFrameId = 0;
function macBookOpenAnimation (timestamp)
{
	const elapsed = (timestamp - prevTimestamp) / 1000;
	if (elapsed <= frameTime) {
		requestAnimationFrame(macBookOpenAnimation);
		return;
	}

	prevTimestamp = timestamp;

  const nowDeg = topGroup.rotation.x;
  if(nowDeg < 2 * rotateDeg)
  {
    topGroup.rotation.x = 0;
    cancelAnimationFrame(openAniFrameId);
    animationFlag = true;
  }else
  {
    topGroup.rotation.x -= rotateDef * rotateDeg;
    openAniFrameId = requestAnimationFrame(macBookOpenAnimation);
  }
	render();
}


const render = () => {
  renderer.render( scene, camera );
}

const macBookClose = ( _e ) => {
  if(!animationFlag) return;
  animationFlag = false;
  const target = S("#macPC");
  const targetHeight = target.offsetHeight;
  const windowY = window.innerHeight;
  const targetY = windowY - target.getBoundingClientRect().y;
  const verticalRatio = targetY*100/windowY;
  if( verticalRatio < 100 && targetY > targetHeight * 2/3
    || verticalRatio >= 100 && target.getBoundingClientRect().y > -targetHeight/5)
  {
    macBookOpenAnimation();
  }else
  {
    macBookCloseAnimation();
  }
}
const macbookObserveOptions = {
  root: null,
  rootMargin: "-26.4% 0px -26.4%",
  threshold: 0
};
const macbookObserveCallback = e => {
	if(!animationFlag) return;
	animationFlag = false;
	if( e[0].isIntersecting )
	{
		macBookOpenAnimation();
	}else
  {
    macBookCloseAnimation();
  }
}
const macbookObserver = new IntersectionObserver(macbookObserveCallback, macbookObserveOptions);

/**
 * トップページのドキュメントがロード待ち
 */
window.addEventListener( 'load', async () => {
  /**
   * 3D部分
   */
  scene = new THREE.Scene();
  camera = new THREE.PerspectiveCamera( 15, width / height, 50, 110 );
  camera.position.set( 0, 5.215918712955123, 100.18628281117698 );
  camera.rotation.set( 4*rotateDeg, 0, 0 );
  scene.add( camera );

  const directLight = new THREE.DirectionalLight(0xFFFFFF, 1);
  scene.add(directLight);

  spotLight = new THREE.SpotLight( 0xF0F0F0, 1 );
  spotLight.position.set( 0, 30, 70 );
  spotLight.angle = Math.PI / 4;
  spotLight.penumbra = 0.01;
  spotLight.decay = 2;
  spotLight.distance = 200;

  spotLight.castShadow = true;
  spotLight.shadow.mapSize.width = 512;
  spotLight.shadow.mapSize.height = 512;
  spotLight.shadow.camera.near = 10;
  spotLight.shadow.camera.far = 200;
  spotLight.shadow.focus = 0.36646909398814564;
  let spotLight2 = new THREE.SpotLight( 0xff0000, 1 );
  spotLight2.copy(spotLight);
  spotLight2.position.set( 40, 50, 70 );
  let spotLight3 = new THREE.SpotLight( 0xffffff, 1 );
  spotLight3.copy(spotLight);
  spotLight3.position.set( -40, 50, 70 );
  scene.add( spotLight );
  scene.add( spotLight2 );
  scene.add( spotLight3 );

  const manager = new THREE.LoadingManager();

  let material = new THREE.MeshPhongMaterial( { color: 0xFFFFFF, dithering: true, transparent: true, opacity: .1 } );

  let geometry = new THREE.PlaneGeometry( 2000, 40 );

  let mesh = new THREE.Mesh( geometry, material );
  mesh.position.set( 0, .5, 10 );
  mesh.rotation.x = - Math.PI * 0.5;
  mesh.receiveShadow = true;
  scene.add( mesh );
  const dracoLoader = new DRACOLoader;
  dracoLoader.setDecoderPath(templatePath + '/module/draco/');
  const loader = new GLTFLoader( manager );
  loader.setDRACOLoader(dracoLoader);

  const displayfObj = await displayLoadFetch(loader,templatePath);
  display = displayfObj.scene;
  display.traverse(obj=>{
    if( obj.isMesh )
    {
     obj.castShadow = true;
    }
  });
  display.scale.set( 1000, 1000, 1000 );
  display.position.set( 49.85-1.2, -1.498221845893311, -0.5 );
  display.rotation.set( Math.PI*60/100, Math.PI , Math.PI/2 );
  scene.add( display );

  const keyboadObj = await keyboadLoadFetch(loader,templatePath);
  keyboad = keyboadObj.scene;
  keyboad.traverse(obj=>{
    if( obj.isMesh )
    {
     obj.castShadow = true;
     obj.receiveShadow = true;
    }
  });

  keyboad.scale.set( 1000, 1000, 1000 );
  keyboad.position.set( 50-1.2, 0, 0 );
  keyboad.rotation.set( Math.PI/2, Math.PI , Math.PI/2 );
  scene.add( keyboad );

  const textureLoader = new THREE.TextureLoader(manager);
  textureLoader.load(
    templatePath + "/img/display.jpg",
    function (texture)
    {
     let displayMat = new THREE.MeshLambertMaterial( {
       color: 0xFFFFFF,
       emissive: 0x000000,
       map: texture,
       transparent: true,
       opacity: 1,
     } );

     let displayGeo = new THREE.PlaneGeometry( 29, 18 );

     displayWindow = new THREE.Mesh( displayGeo, displayMat );
     displayWindow.rotation.x = -Math.PI*1/100;
     displayWindow.position.set( 0, 11, -0.5 );
     scene.add( displayWindow );
     texture.minFilter = THREE.LinearFilter;
    }
  );

  manager.onLoad = function () {
    topGroup = new THREE.Group();
    topGroup.position.set( 0, 1.498221845893311, 0.5  )
    topGroup.add(display);
    topGroup.add(displayWindow);
    scene.add(topGroup);
    topGroup.rotation.x = 91.8 * rotateDeg;
    S("#macPC").style = "";
    render();
    macBookClose();
    macbookObserver.observe(S("#macPC"));
  };

  //

  renderer = new THREE.WebGLRenderer( {
    canvas: S("#macPC"),
    alpha: true,
    antialias: true
  } );
  renderer.setPixelRatio( window.devicePixelRatio );
  renderer.setSize( width, height );
  renderer.setClearColor( 0x000000, 0);
  renderer.outputEncoding = THREE.sRGBEncoding;
  renderer.shadowMap.enabled = true;

  camera.rotation.set( 4*rotateDeg, 0, 0 );

  /**
   * WEB制作部分
   */
  const webServiceContent = S(".web-service");
  if(webServiceContent)
  {
    const webServicesClass = "web-service__nav-item";
    const webServices = S("."+webServicesClass);
    /**
     * target内にランダム入力を開始する
     * @param  {object} target HTML OBJECT
     */

    const stringStart = function (target)
    {
      let tempTextSplitMaxLength = 0;
      if(target[0])
      {
        const tempText = [];
        let tempTextSplit = [];
        let inputMainInterval,inputStartInterval;
        target.forEach((text, i) => {
          tempText.push(text.innerText);
        });
        tempText.forEach((text, i) => {
          let textCutFlag = 0;
          tempTextSplit[i] = [];
          for( var r=0; r<=text.length; r++)
          {
            if( textCutFlag >= text.length )
            {
              tempTextSplitMaxLength = tempTextSplitMaxLength < tempTextSplit[i].length ? tempTextSplit[i].length : tempTextSplitMaxLength;
              break;
            }

            let randomNum;
            if(r===0)
            {
              randomNum = Math.floor( Math.random() ) + 1;
            }else
            {
              randomNum = Math.floor( Math.random() * 2 ) + 1;
            }
            tempTextSplit[i].push( text.substr( textCutFlag, randomNum ) );
            textCutFlag += randomNum;
          }
        });

        let textCount = [], roopStartFlag = 0;
        let roopMainFlag = 0, outputText = [];
        /**
         * ランダム風入力開始前にランダムな文字を5回見せる関数。インターバルを格納するために関数化した
         * stringStart関数内で使用する
         */
        function inputStartIntervalFunction () {
          roopStartFlag++;
          if(roopStartFlag > 6)
          {
            clearInterval(inputStartInterval);
            inputMainInterval = setInterval(inputMainIntervalFunction, 55);

          }
          tempText.forEach((text, i) => {
            if( textCount[i] == null)
            {
              textCount[i] = 1;
            }else if( textCount[i] <= text.length-1 )
            {
              textCount[i] += Math.floor( Math.random() * 1 ) + 1;
            }
            target[i].innerText = getRandumText(textCount[i] + Math.floor( Math.random() ) );
          });
        }
        /**
         * ランダム風入力を開始する。インターバルを格納するために関数化した
         * inputStartIntervalFunction関数内でこの関数から使用する
         */
        function inputMainIntervalFunction ()
        {

          tempTextSplit.forEach((textArr, i) => {
            if(!outputText[i])
            {
              outputText[i] = "";
            }
            outputText[i] += textArr[roopMainFlag] ? textArr[roopMainFlag] : "";

            let tempRandomNum = "";
            if(textArr.length > roopMainFlag+1)
            {
              if( roopMainFlag <= 1 )
              {
                tempRandomNum = getRandumText( textArr[roopMainFlag+1].length*2 );
              }else if( roopMainFlag <= 5 )
              {
                tempRandomNum = getRandumText(textArr[roopMainFlag+1].length + roopMainFlag-2);
              }else
              {
                tempRandomNum = getRandumText(textArr[roopMainFlag+1].length);
              }
            }else
            {
              target[i].innerText = outputText[i];
              return;
            }
            target[i].innerText = outputText[i] + tempRandomNum;
          });
          roopMainFlag++;
          if( tempTextSplitMaxLength === roopMainFlag )
          {
            clearInterval(inputMainInterval);
          }
        }
        inputStartInterval = setInterval(inputStartIntervalFunction, 60);
      }
    }
    const serviceObject = {
      corporate: [
        "Corporate Site",
        "コーポレート",
        `<p class="web-service__text"><span class="jsInputString">コーポレートサイトは会社の顔です。</span></p>
        <p class="web-service__text"><span class="jsInputString">サイトの内容には、会社の事業やサービス情報を記載します。</span><span class="jsInputString">求人者が応募をする際や顧客が契約先を選ぶ際に参考にされることが多く、</span><span class="jsInputString">サイトの有無で会社の信頼が変わってくる時代になっています。</span></p>
        <p class="web-service__text"><span class="jsInputString">イメージカラーやコンセプトに合ったサイトを作って<span class="jsInputString">会社のブランディングを目指します。</span></p>`
      ],
      media: [
        "Media Site",
        "メディア",
        `<p class="web-service__text"><span class="jsInputString">メディアサイトは、定期的に新しいページや</span><span class="jsInputString">記事を更新していくブログの機能がついたWebサイトです。コーポレートサイトとの相性も良く、</span><span class="jsInputString">事業の詳しい情報や最新情報を載せることができます。</span></p>
        <p class="web-service__text"><span class="jsInputString">定期的なコンテンツの更新はGoogle検索の上位に</span><span class="jsInputString">載りやすくする効果もあり、広告を利用するよりも安価に集客することができます。</span></p>`
      ],
      promotion: [
        "Promotion Site",
        "プロモーション",
        `<p class="web-service__text"><span class="jsInputString">プロモーションサイトはGoogleや</span><span class="jsInputString">TwitterなどのSNSで広告から直接繋がるWebサイトです。</span></p>
        <p class="web-service__text"><span class="jsInputString">商品の販売やサービスの見積もり請求、求人情報の</span><span class="jsInputString">公開、ブランドイメージの強化など、様々な促進効果を目的とします。</span></p>
        <p class="web-service__text"><span class="jsInputString">Webサイトの作成だけでなく、広告用の画像や動画を</span><span class="jsInputString">作成するプランもご用意しています。</span></p>`
      ],
      product: [
        "Product Site",
        "プロダクト",
        `<p class="web-service__text"><span class="jsInputString">プロダクトサイトは特に紹介したい商品やサービスについて</span><span class="jsInputString">詳しくまとめたWebサイトです。</span></p>
        <p class="web-service__text"><span class="jsInputString">コーポレートサイトやメディアサイトの一部で紹介するよりも</span><span class="jsInputString">詳しくその商品の専門的なサイトにする</span><span class="jsInputString">ことで購入や見積り請求に繋がりやすくなります。</span></p>
        <p class="web-service__text"><span class="jsInputString">Google広告を利用することで、さらに多くのターゲットに繋がりやすくなります。</span></p>`
      ],
    }
    const serviceOrder = {
      corporate: 0,
      media: 1,
      promotion: 2,
      product: 3,
    }
    const serviceNameArray = [ "corporate", "media", "promotion", "product" ];
    let undoTmp = [], redoTmp = [];
    const leftClickable = "virtual-browser__arrow-left--clickable";
    const rightClickable = "virtual-browser__arrow-right--clickable";
    let titleChangeFlag = false;

    const serviceNavigation = S(".jsServiceNavigation");
    /**
     * サービスが変わった時にナビゲーション部分の変更を制御する
     * @param  {string} service サービス名が入る
     */
    const navigationChange = service => {
      selectOut(S("."+webServicesClass+"--select"));
      sleep(300)
      .then(()=>{
        serviceNavigation[serviceOrder[service]].classList.add(webServicesClass+'--select');
      })
    }

    const cloneWrapper = S(".jsCloneWrapper");
    const serviceTitle = S(".jsServiceTitle");
    const cloneTitle = S(".jsCloneTitle");
    /**
     * サービスが変わった時にタイトル部分の変更を制御する
     * @param  {string} service サービス名が入る
     */
    const titleChange = service => {
      cloneWrapper.style.width = "100%";
      sleep(500)
      .then( ()=>{
        cloneTitle.forEach((item, i) => {
          item.innerHTML = serviceObject[service][i];
        });
        serviceTitle.forEach((item, i) => {
          item.innerHTML = serviceObject[service][i];
        });

        stringStart(cloneTitle);
        setTimeout(()=>{
          cloneTitle.forEach((titleDom, i) => {
            titleDom.style.opacity = 1;
          });
        },100);
        return sleep(2064);
      })
      .then( ()=>{
        cloneWrapper.style.width = "";
        return sleep(500);
      })
      .then( ()=>{
        cloneTitle.forEach((titleDom, i) => {
          titleDom.style.opacity = "";
        });
      });
    }

    const serviceDescription = S(".jsServiceDescription");
    const discriptionWrapper = serviceDescription.parentNode;
    /**
     * サービスが変わった時に説明部分の変更を制御する
     * @param  {string} service サービス名が入る
     */
    const descriptionChange = service => {
      discriptionWrapper.style.minHeight = discriptionWrapper.clientHeight + "px";
      serviceDescription.classList.add("web-service__description--delete");
      sleep(500)
      .then(()=>{
        serviceDescription.innerHTML = serviceObject[service][2];
        stringStart(S(".jsInputString"));
        return sleep(100);
      })
      .then(()=>{
        serviceDescription.classList.remove("web-service__description--delete");
        return sleep(1200);
      })
      .then(()=>{
        discriptionWrapper.style.minHeight = "";
      })
    }

    const serviceImage = S(".jsServiceImage");
    const serviceLoader = S(".jsServiceLoader");
    const loaderClassName = "virtual-browser__loader";
    /**
     * サービスが変わった時に画像部分の変更を制御する
     * @param  {string} service サービス名が入る
     */
    const browserImageChange = service => {
      serviceLoader.classList.add(loaderClassName + "--loading");
      sleep(1000)
      .then(()=>{
        S(".virtual-browser__main-image--select")
        .classList.remove("virtual-browser__main-image--select");
        serviceImage[serviceOrder[service]].classList.add("virtual-browser__main-image--select");
        return sleep(1000);
      })
      .then(()=>{
        serviceLoader.classList.add(loaderClassName + "--loaded");
        return sleep(1000);
      })
      .then(()=>{
        serviceLoader.classList.remove(loaderClassName + "--loading");
        serviceLoader.classList.remove(loaderClassName + "--loaded");
        titleChangeFlag = false;
      })
    }
    /**
     * サービスを変更する
     * @param  {string} service サービス名が入る
     */
    const serviceChangeSet = service => {
      navigationChange(service);
      titleChange(service);
      descriptionChange(service);
      browserImageChange(service);
    }

    /**
     * ナビゲーション部分のホバーの時に時差でクラスを追加する
     * @param  {object} target ナビゲーションのHTMLオブジェクト
     */
    const hoverIn = target => {
      target.classList.add(webServicesClass+'--up');
      setTimeout(()=>{
        target.classList.add(webServicesClass+'--hover');
      },200);
    }
    /**
     * ナビゲーション部分のホバーアウトの時に時差でクラスを削除する
     * @param  {object} target ナビゲーションのHTMLオブジェクト
     */
    const hoverOut = target => {
      target.classList.remove(webServicesClass+'--hover');
      setTimeout( ()=>{
        target.classList.remove(webServicesClass+'--up');
      }, 200 );
    }
    /**
     * サービスが変更された時に時差でクラスを削除する
     * @param  {object} target ナビゲーションのHTMLオブジェクト
     */
    const selectOut = target => {
      target.classList.remove(webServicesClass+'--select');
      target.classList.add(webServicesClass+'--hover');
      target.classList.add(webServicesClass+'--up');
      setTimeout( ()=>{
        hoverOut(target);
      }, 500 );
    }
    webServices.forEach((item, i) => {
      item.addEventListener( 'mouseover', e =>{
        const target = e.currentTarget;
        if( target.dataset.service === webServiceContent.dataset.selectService
          || target === e.target )
        {
          return;
        }
        hoverIn(target);
      },{passive: true});
      item.addEventListener( "mouseout", e =>{
        const target = e.currentTarget;
        if( target.dataset.service === webServiceContent.dataset.selectService
          || target === e.target )
        {
          return;
        }
        setTimeout( ()=>{ hoverOut(target); }, 200 );
      },{passive: true});
      item.addEventListener( "click", e=>{
        const target = e.currentTarget;
        if( target.dataset.service === webServiceContent.dataset.selectService
          || target === e.target )
        {
          return;
        }
        if(titleChangeFlag)
        {
          return;
        }
        titleChangeFlag = true;
        redoTmp = [];
        virtualBrowserRight.classList.remove(rightClickable);
        if(!undoTmp.length)
        {
          virtualBrowserLeft.classList.add(leftClickable);
        }
        undoTmp.push(serviceOrder[webServiceContent.dataset.selectService]);
        webServiceContent.dataset.selectService = target.dataset.service;
        serviceChangeSet(webServiceContent.dataset.selectService);
      });
    });// end webServices forEach
    const virtualBrowserLeft = S(".jsVirtualBrowserLeft");
    const virtualBrowserRight = S(".jsVirtualBrowserRight");
    virtualBrowserLeft.addEventListener('click',()=>{
      if(titleChangeFlag)
      {
        return;
      }
      titleChangeFlag = true;
      const serviceId = undoTmp.pop();
      if(serviceId == undefined)
      {
        return;
      }
      if(!redoTmp.length)
      {
        virtualBrowserRight.classList.add(rightClickable);
      }
      if(!undoTmp.length)
      {
        virtualBrowserLeft.classList.remove(leftClickable);
      }
      redoTmp.push(serviceOrder[webServiceContent.dataset.selectService]);
      webServiceContent.dataset.selectService = serviceNameArray[serviceId];
      serviceChangeSet(serviceNameArray[serviceId]);
    });
    virtualBrowserRight.addEventListener('click',()=>{
      if(titleChangeFlag)
      {
        return;
      }
      titleChangeFlag = true;
      const serviceId = redoTmp.pop();
      if(serviceId == undefined)
      {
        return;
      }
      if(!redoTmp.length)
      {
        virtualBrowserRight.classList.remove(rightClickable);
      }
      if(!undoTmp.length)
      {
        virtualBrowserLeft.classList.add(leftClickable);
      }
      undoTmp.push(serviceOrder[webServiceContent.dataset.selectService]);
      webServiceContent.dataset.selectService = serviceNameArray[serviceId];
      serviceChangeSet(serviceNameArray[serviceId]);
    });

    S(".jsVirtualBrowserUpdate").addEventListener('click',()=>{
      if(titleChangeFlag)
      {
        return;
      }
      titleChangeFlag = true;
      browserImageChange(webServiceContent.dataset.selectService);
    });
  }
  /**
   * 制作実績部分
   */
  const webWorksContents = S(".web-works");
  if( webWorksContents )
  {
    particlesJS("web-works-particle",{
      "particles": {
        "number": {
          "value": 246,
          "density": {
            "value_area": 2426
          }
        },
        "color": {
          "value": [
            "#ff0000","#00ff00","#0000ff",
            "#ffa8a8","#ffa8d3","#a8a8ff","#a8d3ff"
          ]
        },
        "opacity": {
          "value": 0.4,
          "random": false,
        },
        "size": {
          "value": 4,
          "random": true,
        },
        "line_linked": {
          "enable": true,
          "distance": 150,
          "color": "#0426ff",
          "opacity": 0.1657,
          "width": 1.7
        },
        "move": {
          "speed": 2,
          "random": true,
          "out_mode": "bounce",
          "bounce": true,
          "attract": {
            "enable": false,
          }
        }
      },
      "interactivity": {
        "events": {
          "onhover": {
            "enable": false,
          },
          "onclick": {
            "enable": false,
          },
          "resize": true
        },
      },
      "retina_detect": true
    });

    const webWorksCover = S(".jsWebWorksCover");
    const appGroup = S(".web-works .jsAppGroup");
    let appSlider;
    /**
     * 実績ボックスが選択されて拡大された時のボックスの横幅
     * @return {string} ウィンドウの大きさによって変える
     */
    const getAppWidth = function () {
      const windowWidth = window.innerWidth;
      const windowHeight = window.innerHeight;
      if(windowWidth < windowHeight)
      {
        if(windowWidth < 1200)
        {
          return "72vw";
        } else
        {
          return "80rem";
        }
      } else
      {
        if(windowHeight < 1200)
        {
          return "65vh";
        } else
        {
          return "80rem";
        }
      }
    }
    /**
     * ウィンドウ変動で実績ボックスの拡大時の横幅を与える
     */
    let lastInnerWidth = 0;
    const resizeAppWidth = () => {
      const tmpInnerWidth = window.innerWidth;
      if(lastInnerWidth !== tmpInnerWidth)
      {
        lastInnerWidth = tmpInnerWidth;
      }else
      {
        return;
      }
      const appWidth = getAppWidth();
      appGroup.forEach((app, i) => {
        app.setAttribute("style","--app-width:" + appWidth + ";");
      });
    }
    resizeAppWidth();
    window.addEventListener("resize", resizeAppWidth ,{passive:true});
    /**
     * ボックスと外のフィルターにクラストグルする
     * @param  {Object} app 実績ボックスのHTMLオブジェクト
     * @param  {String} modify default= "--clicked"
     */
    const appClicked = (app,modify="--clicked") => {
      app.classList.toggle("app-group"+modify);
      webWorksCover.classList.toggle("web-works__cover"+modify);
    }
    let appClickFlag = false;
    let coverClickFlag = false;
    /**
     * スクロール制御
     */
    const stopScroll = e => {
      e.preventDefault();
    }
    /**
     * クリック後のスライダーのプラグイン
     * @param  {Object} slider
     */
    const appNavigation = slider => {
      let arrowLeft, arrowRight, dots;
      const removeElement = el => {
        if(!el) return;
        el.classList.remove("app-group__arrow--visible");
        el.classList.remove("app-group__dots--visible");
        sleep(300)
        .then(()=>{
          el.parentNode.removeChild(el);
        });
      }
      const createDiv = className => {
        const div = document.createElement("div");
        const classNames = className.split(" ");
        classNames.forEach((name) => div.classList.add(name));
        return div;
      }
      const markup = remove => {
        arrowMarkup(remove);
        dotMarkup(remove);
      }
      const arrowMarkup = remove => {
        if(remove)
        {
          removeElement(arrowLeft);
          removeElement(arrowRight);
          return;
        }
        arrowLeft = createDiv("app-group__arrow app-group__arrow--left");
        arrowLeft.addEventListener("click",() => slider.prev());
        arrowRight = createDiv("app-group__arrow app-group__arrow--right");
        arrowRight.addEventListener("click",() => slider.next());
        slider.container.parentNode.appendChild(arrowLeft);
        slider.container.parentNode.appendChild(arrowRight);
        sleep(10)
        .then(()=>{
          arrowLeft.classList.add("app-group__arrow--visible");
          arrowRight.classList.add("app-group__arrow--visible");
        });

      }
      const dotMarkup = remove => {
        if( remove )
        {
          removeElement(dots);
          return;
        }
        dots = createDiv("app-group__dots");
        slider.container.parentNode.appendChild(dots);
        if(slider.container.children.length === 1) return;
        slider.track.details.slides.forEach((_e, idx) => {
          const dot = createDiv("app-group__dot");
          dot.addEventListener("click", () => slider.moveToIdx(idx));
          dots.appendChild(dot);
        })
        sleep(10)
        .then(()=>{
          dots.classList.add("app-group__dots--visible");
        });
      }
      const updateClasses = () => {
        const slide = slider.track.details.rel
        slide === 0
          ? arrowLeft.classList.add("app-group__arrow--disabled")
          : arrowLeft.classList.remove("app-group__arrow--disabled");
        slide === slider.track.details.slides.length - 1
          ? arrowRight.classList.add("app-group__arrow--disabled")
          : arrowRight.classList.remove("app-group__arrow--disabled");
        Array.from(dots.children).forEach(function (dot, idx) {
          idx === slide
            ? dot.classList.add("app-group__dot--active")
            : dot.classList.remove("app-group__dot--active");
        });
      }
      slider.on("created", () => {
        markup();
        updateClasses();
      })
      slider.on("slideChanged", () => {
        updateClasses();
      })
      slider.on("destroyed", () => {
        markup(true);
      })
    }
    /**
     * 実績ボックスを開く時の動きを制御する
     * @param {Object} e event引数
     * @param {Object} this.name.app 開くボックスのHTMLオブジェクト
     * @param {Int} this.name.order 左から何番目のボックスかどうか 0-3
     */
    function worksAppOpen (e) {
      if(appClickFlag) return;
      appClickFlag = true;
      if(is_SP)
      {
        document.addEventListener("touchmove",stopScroll,{passive:false});
      }else
      {
        document.addEventListener("mousewheel",stopScroll,{passive:false});
        document.addEventListener("touchmove",stopScroll,{passive:false});
      }
      S(".app-group__content",true)[this.name.order].classList.add("jsAppKeenSlider-"+this.name.order);
      const target = this.name.app;
      const appCoordinate = this.name.app.getBoundingClientRect();
      appClicked(target);
      target.style.top = (appCoordinate.height/2) + appCoordinate.top + "px";
      target.style.left = (appCoordinate.width/2) + appCoordinate.left + "px";
      webWorksCover.appendChild(target);

      sleep(100)
      .then(()=>{
        appClicked(target,"--selected");
        return sleep(500);
      })
      .then(()=>{
        target.querySelectorAll('.jsAppItemAnchor').forEach((anchor, i) => {
          anchor.removeEventListener('click',stopScroll,{passive:false});
        });

        coverClickFlag = true;
        appSlider = new KeenSlider(
          ".jsAppKeenSlider-"+this.name.order,
          {
            loop: false,
            slides: {
              origin: "center",
              perView: "auto",
              spacing: 0,
            },
          },
          [appNavigation]
        )
      });
    }
    const workAppTitle = S(".jsWorkAppTitle");
    const is_SP =  navigator.userAgent.match(/(iPhone|iPad|iPod|Android)/i);
    const worksCategory = {
      corporate: [],
      media: [],
      promotion: [],
      product: []
    };
    worksFetch()
      .then( data => {
        data.shift();
        data.forEach((item, i) => {
          worksCategory[item.category_slug].push({
            name: item.title,
            image: item.favicon,
            id: item.id,
          });
        });
        return;
      })
      .then(()=>{
        appGroup.forEach( (app,i) => {
          const appPageContent = app.querySelector('.keen-slider');
          const serviceTitle = app.children[0].innerText;
          let appPageDiv = document.createElement('div');
          appPageDiv.classList.add('app-group__page','keen-slider__slide');

          worksCategory[serviceTitle.toLowerCase()].forEach( (item, i) => {
            if( Number.isInteger(i / 9) && i !== 0 )
            {
              appPageContent.appendChild(appPageDiv);
              appPageDiv = '';
              appPageDiv = document.createElement('div');
              appPageDiv.classList.add('app-group__page','keen-slider__slide');
            }

            const appItem = document.createElement('div');
            appItem.classList.add('app-group__item');
            appPageDiv.appendChild(appItem);

            const appItemAnchor = document.createElement('a');
            appItemAnchor.classList.add('jsAppItemAnchor');
            appItemAnchor.addEventListener('click',stopScroll,{passive:false});
            appItemAnchor.href = homeUrl + '/works/' + item.id;
            appItem.appendChild(appItemAnchor);

            const appItemImageDiv = document.createElement('div');
            appItemImageDiv.classList.add('app-group__app-image');
            appItemAnchor.appendChild(appItemImageDiv);

            const appItemImage = document.createElement('img');
            appItemImage.src = item.image ? item.image : templatePath + '/img/nofavicon.png';
            appItemImage.width = 159;
            appItemImage.height = 159;
            appItemImage.alt = item.name + 'のアイコン';
            appItemImageDiv.appendChild(appItemImage);

            const appItemTitle = document.createElement('p');
            appItemTitle.classList.add('app-group__app-title');
            appItemTitle.innerText = item.name;
            appItemAnchor.appendChild(appItemTitle);
          });
          appPageContent.appendChild(appPageDiv);


          const group = {app:app,order:i};
          workAppTitle[i].addEventListener('click',{name: group, handleEvent: worksAppOpen});
          app.addEventListener('click',{name: group, handleEvent: worksAppOpen});
        });
      });

    webWorksCover.addEventListener('click', (e)=>{
      if(!coverClickFlag || e.target !== e.currentTarget.children[0]) {
        return;
      }
      coverClickFlag = false;
      appClickFlag = false;
      const target = e.currentTarget;
      target.querySelectorAll('.jsAppItemAnchor').forEach((anchor, i) => {
        anchor.addEventListener('click',stopScroll,{passive:false});
      });
      const child = target.children[1];
      appClicked(child,"--selected");
      if(appSlider.track.details.abs > 0)
      {
        appSlider.moveToIdx(0);
        appSlider.on('animationEnded',()=>{
          appSlider.destroy();
        })
      }else
      {
        appSlider.destroy();
      }
      sleep(300)
      .then(()=>{
        S(".web-works__app")[child.dataset.appOrder].appendChild(child)
        child.style.left = "";
        child.style.right = "";
        child.style.top = "";
        appClicked(child);
        document.removeEventListener("mousewheel",stopScroll,{passive:false});
        document.removeEventListener("touchmove",stopScroll,{passive:false});
      });

    })
  }
  /**
   * 料金部分
   */
  const priceArea = S('.jsPriceCardArea');
  if(priceArea)
  {
    const priceCard = priceArea.querySelectorAll('.jsPriceCard');
    const priceObserveOptions = {
      rootMargin: '-40% 0px -30%',
    };
    const priceObserveCallback = e => {
      if(e[0].isIntersecting)
      {
        priceCard.forEach((card, i) => {
          card.classList.add('price-card--visible');
        });
        priceObserver.unobserve(priceArea);
      }
    }
    const priceObserver = new IntersectionObserver(priceObserveCallback, priceObserveOptions);
    priceObserver.observe(priceArea);
  }
  /**
   * 制作の流れ部分
   */
  const webFlowItem = S(".jsWebFlowItem");
  if(webFlowItem.length !== 0)
  {
    let webFlowAniRequestId, webFlowOrder = webFlowItem.length-1,
        webFlowItemClassName = 'web-flow__item--select';

    let webFlowObserveFlag = false; //制作の流れの要素が画面内かどうかを判断する
    let webFlowOnHover = false;
    let webFLowAnimationTimeout; //制作の流れのアニメーションのループIDを格納する
    /**
     * 制作の流れのアニメーションを中断
     */
    const stopWebFlowAnimation = () => {
      clearTimeout(webFLowAnimationTimeout);
    }
    /**
     * 制作の流れのアニメーションさせる
     * @return {boolean} 監視フラグが立っていない時は動作させず falseを返す
     */
    const webFlowAnimation = () => {
      clearTimeout(webFLowAnimationTimeout);
      if(webFlowObserveFlag) return false;
      webFLowAnimationTimeout = setTimeout( ()=>{
        webFlowNext();
      },1500);
    }
    /**
     * 制作の流れの選択を次に移す
     * @param {int} order 任意の場所に移動させる場合
     * @return {boolean}
     */
    const webFlowNext = (order = '') => {
      webFlowItem[webFlowOrder].classList.remove(webFlowItemClassName);
      if(order !== '' && order < webFlowItem.length)
      {
        webFlowOrder = order;
      }else
      {
        webFlowOrder = webFlowOrder === webFlowItem.length-1 ? 0 : webFlowOrder+1;
      }
      webFlowItem[webFlowOrder].classList.add(webFlowItemClassName);
      setTimeout(()=>{
        webFlowAnimation();
      }, 300);
    }

    webFlowItem.forEach((item, i) => {
      item.addEventListener('click', ()=>{
        webFlowNext(i);
      })
    });

    const webFlowItemObserveOptions = {
      root: null,
      rootMargin: '10px 0px 10px',
      threshold: .5
    };
    const webFlowItemObserveCallback = e => {
      webFlowObserveFlag  = e[0].isIntersecting ? false : true;
      webFlowAnimation();
    }
    const webFlowItemObserver = new IntersectionObserver(webFlowItemObserveCallback, webFlowItemObserveOptions);
    webFlowItemObserver.observe(S('.jsWebFlow'));
  }
  /**
   * よくある質問部分
   */
  const faq = S('.jsFAQ');
  if( faq )
  {
    const faqData = [
      [
        {
          q: '無料のホームページ作成ツールとは何が違いますか？',
          a: '無料の作成ツールではユーザーを意識したデザインやSEOのために最適化されたサイトの全てを対応しきれません。<br>特に、ZATYではオーダーメイドならではの「お客様のイメージしているWEBサイトを完全に再現」を目指して制作いたします。'
        },
        {
          q: 'SEO対策はしてくれますか？',
          a: 'ZATYではGoogle提供のパフォーマンスレポート作成サービスを用いてSEO項目において100点になるようサイトコーディングを行なっています。<br>さらにGoogleで検索したときにユーザーの目にとまりやすくする構造化データの制作も必ず行なっています。'
        },
        {
          q: '制作会社です。下層ページの一部だけの制作は可能ですか？',
          a: '可能です。例えば、下層単独ページの作成の場合、<a href="'+homeUrl+'/pricing">料金ページ</a>にて記載してある「下層ページ」のみの受注で60,000円〜承っております。デザインや内容によって価格は増減する可能性がありますので、ご気軽にお問い合わせください。'
        },
      ],
      [
        {
          q: 'まだ悩んでいるので相談したいのですが・・・',
          a: 'ZoomやLINEにて無料でオンライン相談を承っております。見積もりやデザイン、WEBサイトの仕組みのことなどどのようなご相談でも構いません。まずはご気軽にお問い合わせからご連絡ください。'
        },
        {
          q: 'ホームページの内容や構成はどれくらい決めておいた方がいいですか？',
          a: '文章や画像のご用意が多くあるとお見積もりから制作までを円滑に進めることができます。<br>構成は打ち合わせの際にテーマカラーや全体的なイメージをお伺いした上で決定することも可能です。'
        },
        {
          q: '無料の打ち合わせは何回できますか？',
          a: 'お問い合わせ後、オンラインや訪問にて複数回の打ち合わせ行い、サイトイメージや文章や画像等のヒアリングをいたします。制作のお見積りを作成し、ご契約まで何度でもご相談いただけますので、ご気軽にお問い合わせください。'
        },
      ],
      [
        {
          q: '製作費用はどれくらいですか？',
          a: 'ZATYのWEB制作では平均30万円~70万円程度の受注を承っています。サイトのページ数やデザインによっては大きく費用が増減する可能性があります。<br>詳しくは料金ページにて細かく分類していますのでご覧ください。'
        },
        {
          q: 'なるべく制作費用を抑えたいです。',
          a: 'ZATY独自作成のWordPressのテンプレートをベースにしたプランのご用意がございます。プラグインの導入や無料デザインテンプレートの使用で比較的お安くホームページの制作が可能です。'
        },
        {
          q: '動きがあるサイトは値段が上がりますか？',
          a: 'マウスのホバーやクリックによるナビゲーション等のアニメーションはあって当然です。ZATYではそのような単純かつ目を引くアニメーションは追加料金なしで実装いたします。特に複雑なアニメーションをZATYに完全にお任せいただくことも可能ですのでご気軽にお問い合わせください。'
        },
      ],
      [
        {
          q: '保守・運用とはなんですか？',
          a: 'WEBサイトは完成して公開することが「ゴール」ではありません。定期的なメンテナンスや、情報を最新にする更新や修正をZATYの運用チームがメンテナンスのアドバイス・代行いたします。'
        },
        {
          q: 'サーバーは用意してくれますか？',
          a: 'ZATYでは現在レンタルサーバー「Xserver」様のサービスを使用してWEBサイトの公開を代行しております。その場合はレンタルサーバーの契約費用と継続費用を頂きます。詳しくは<a href="'+homeUrl+'/pricing">料金ページ</a>にまとめていますのでご覧ください。'
        },
      ],
    ];

    /**
     * FAQのリセット用
     * @param  {String} q Question部分
     * @param  {String} a Answer部分
     * @return {Object} HTMLオブジェクト
     */
    const createFaqItem = (q,a) => {
      const returnDom = createDom('div',['jsFAQItem','web-faq__item','jsBeforeCalc']);
      returnDom.style.position = 'absolute';
      const eyecatch = createDom('div',['web-faq__eyecatch','jsFAQEyeCatch'],'',[],returnDom);
      createDom('span','jsTapNum','タップ',[],eyecatch);
      createDom('div','web-faq__question-icon','Q',[],returnDom);
      const question = createDom('h3','web-faq__name',q,[],returnDom);
      const faqButton = createDom('span',['web-faq__button','jsFAQButton'],'',[],question);
      const answer = createDom('div',['web-faq__answer','jsAnswer'],'',[],returnDom);
      createDom('div','web-faq__answer-icon','A',[],answer);
      createDom('p','web-faq__text',a,[],answer);

      eyecatch.addEventListener('click',toggleAnswer);
      eyecatch.style.opacity = 0;
      faqButton.addEventListener('click',toggleAnswer);

      return returnDom;
    }
    /**
     * 開閉イベントのコールバック
     * @param  {Event} e
     */
    const toggleAnswer = e => {

      const targetParent = e.target.closest('.jsFAQItem');
      const targetAnswer = targetParent.querySelector('.jsAnswer');
      const targetButton = targetParent.querySelector('.jsFAQButton');
      const targetTap = targetParent.querySelector('.jsFAQEyeCatch');

      targetTap.style.opacity = 0;
      if(targetButton.classList.toggle('web-faq__button--view'))
      {
        targetAnswer.style.top = targetParent.clientHeight + 16 + 'px';
        targetParent.style.paddingBottom = targetAnswer.clientHeight + 16 + 'px';
      }else
      {
        sleep(300)
        .then(()=>{
          targetAnswer.style.top = '0px';
          targetParent.style.paddingBottom = '0px';
        });
      }
      targetAnswer.classList.toggle('web-faq__answer--view');
    }
    /**
     * Answerの生成時とwindow幅変更時に使用
     * @param {Object} item Q&AのHTMLDOM
     */
    const setHeight = item => {
      item.setAttribute('style','--answer-height:' + (Number(item.clientHeight) + 3) + 'px;');
    }
    const closeAnswer = item => {
      const targetParent = item.closest('.jsFAQItem');
      const targetAnswer = targetParent.querySelector('.jsAnswer');
      const targetButton = targetParent.querySelector('.jsFAQButton');
      targetButton.classList.remove('web-faq__button--view');
      targetAnswer.classList.remove('web-faq__answer--view');
      sleep(350)
      .then(()=>{
        targetAnswer.style.top = '0px';
        targetParent.style.paddingBottom = '0px';
      })
    }
    let heightTimer = null;
    const setAllAnswerHeight = () => {
      clearTimeout( heightTimer );
      heightTimer = setTimeout(()=>{
        S('.jsAnswer',true).forEach((item, i) => {
          setHeight(item);
          closeAnswer(item);
        });
        S('.jsFAQItem',true).forEach((item, i) => {
          setHeight(item);
        });
      },100);
    }
    setAllAnswerHeight();
    window.addEventListener('resize',setAllAnswerHeight,{passive: true});
    const faqButton = S('.jsFAQButton',true);
    const faqEye = S('.jsFAQEyeCatch',true);
    faqButton.forEach((button, i) => {
      button.addEventListener('click',toggleAnswer);
    });
    faqEye.forEach((button, i) => {
      button.addEventListener('click',toggleAnswer);
    });

    const closeQuestion = async item => {
      const targetAnswer = item.querySelector('.jsAnswer');
      const targetEye = item.querySelector('.jsFAQEyeCatch');
      targetEye.style.opacity = 0;
      closeAnswer(targetAnswer)
      item.classList.remove('web-faq__item--view');
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve(item.clientHeight);
        }, 500);
      });
    }
    const openQuestion = item => {
      const targetEye = item.querySelector('.jsFAQEyeCatch');
      item.classList.add('web-faq__item--view');
      sleep(300)
      .then(()=>{
        targetEye.style.opacity = 1;
      });
    }
    const faqContent = S('.jsFAQContent');
    const changeQuestion = async num => {

      let questionAfterHeight = 0;
      const itemArray = [];
      let tmpWidth = 0;
      S('.jsFAQItem',true).forEach((item, i) => {
        item.classList.add('jsAfterCalc');
        itemArray.push(item);
        tmpWidth = item.clientWidth;
      });
      faqData[num].forEach((data, i) => {
        faqContent.appendChild(createFaqItem(data.q,data.a));
      });
      const afterQuestionArray = S('.jsBeforeCalc',true);
      afterQuestionArray.forEach((item, i) => {
        questionAfterHeight += item.clientHeight + 40;
        item.style.width = tmpWidth+'px';
        item.classList.remove('jsBeforeCalc');
      });
      questionAfterHeight -= 40;

      let questionBeforeHeight = 0;
      await Promise.all(itemArray.map(async item => {
        let itemHeight = await closeQuestion(item)
        questionBeforeHeight += itemHeight + 40;
      }));

      questionBeforeHeight -= 40;
      faqContent.style.height = questionBeforeHeight + 'px';
      setAllAnswerHeight();
      sleep(100)
      .then(()=>{
        faqContent.style.height = questionAfterHeight + 'px';
        S('.jsAfterCalc',true).forEach((item, i) => {
          item.parentNode.removeChild(item);
        });
        S('.jsFAQItem',true).forEach((item, i) => {
          item.style.position = '';
          item.style.width = '';
          openQuestion(item);
          item.querySelector('.jsTapNum').setAttribute('style','--tap:'+i+';');
        });
        return sleep(300)
      })
      .then(()=>{
        faqContent.style.height = '';
      });

    }
    S('.jsFAQNav',true).forEach((item, i) => {
      item.addEventListener('click', e => {
        const classname = 'web-faq__nav-item--current';
        if(e.currentTarget.classList.contains(classname)) return;
        const current = S('.'+classname);
        current.classList.remove(classname);
        e.currentTarget.classList.add(classname);

        changeQuestion(i);
      });
    });

  }
  /**
   * ZATYのブログ部分
   */
  const topBlogArea = S('.jsBlogArea');
  if( topBlogArea )
  {
    const thumbnailItemDOM = (itemObj,i) => {
      const indexClass = i===0 ? ' thumbnail-item--index': '';
      const imgHTML = itemObj.thumbnail_url !== '' ? `<picture>
      <img src="${itemObj.thumbnail_url}" alt="ZATYブログ人気記事のサムネイル">
      </picture>` : `<picture>
      <source srcset="${templatePath + '/img/noImage.webp'}" type="image/webp">
      <img src="${templatePath + '/img/noImage.jpg'}" alt="ZATYブログ人気記事のサムネイル">
      </picture>`;
      return `<div class="thumbnail-item ${indexClass} keen-slider__slide jsThumbnailItem">
        <a href='${itemObj.permalink}'>
          <p class="thumbnail-item__more">この記事を見る</p>
          <div class="thumbnail-item__item">
            <figure class="thumbnail-item__thumbnail">
              ${imgHTML}
              <div class="thumbnail-item__views">${itemObj.view}<span class="thumbnail-item__uni">views</span></div>
            </figure>
            <p class="thumbnail-item__date">
              <svg class="thumbnail-item__write-svg" xmlns="http://www.w3.org/2000/svg" width="12.06" height="17.34" viewBox="0 0 12.06 17.34" viewBox="0 0 12.06 17.34" fill="#333">
                <rect x="2.53" y=".95" width="7" height="12" transform="translate(4.28 -2.08) rotate(30)"/>
                <path d="M6.37,1.37l4.33,2.5L5.33,13.16,1.02,15.62l-.02-4.96L6.37,1.37m-.37-1.37L0,10.39l.03,6.95,6.03-3.45L12.06,3.5,6,0h0Z"/>
                <polygon points=".03 17.34 .02 13.87 3.05 15.62 .03 17.34"/>
              </svg>
              ${itemObj.date}
            </p>
            <p class="thumbnail-item__title">${itemObj.title}</p>
            <p class="thumbnail-item__category">
              <svg class="thumbnail-item__category-label" xmlns="http://www.w3.org/2000/svg" width="160" height="100" viewBox="0 0 160 100" fill="#333">
                <path d="M140,20v60H49.61l-24-30,24-30h90.39M160,0H40L0,50l40,50h120V0h0Z"/>
                <path d="M60,40c-5.52,0-10,4.48-10,10s4.48,10,10,10,10-4.48,10-10-4.48-10-10-10h0Z"/>
              </svg>
              ${itemObj.category_name}
            </p>
          </div>
        </a>
      </div>`;
    }
    blogFetch()
      .then( data => {
        data.forEach((item, i) => {
          item.thumbnail_url = item.thumbnail_url ? item.thumbnail_url : '';
          topBlogArea.innerHTML += thumbnailItemDOM(item,i);
        });
        return;
      })
      .then(()=>{
        const blogSlider = new KeenSlider(
          ".jsBlogArea",
          {
            loop: true,
            slides: {
              origin: "center",
              perView: "auto",
              spacing: 16,
            },
          },
          [blogKeenNavigation]
        );
      });
    const blogKeenNavigation = slider => {
      const prevButton = S('.jsBlogAreaPrev');
      const nextButton = S('.jsBlogAreaNext');
      const indexItemClass = 'thumbnail-item--index';

      const clickDesable = e => {
        e.preventDefault();
      }

      const thumbnailItem = S('.jsThumbnailItem');
      thumbnailItem.forEach((item, i) => {
        item.addEventListener('click',clickDesable);
      });

      const resetIndex = item => {
        item.classList.remove(indexItemClass);
        item.addEventListener('click',clickDesable);
      }
      const setIndex = item => {
        item.classList.add(indexItemClass);
        item.removeEventListener('click',clickDesable);
      }
      const calcCurrentIdx = num => {
        let returnNum;
        if( num < 0 )
        {
          if( num % 7!==0 )
          {
            returnNum = num % 7 + 7;
          }else if (num % 7 === 0)
          {
            returnNum = 0;
          }
        }else
        {
          if( num > 6)
          {
            returnNum = num % 7;
          }else
          {
            returnNum = num;
          }
        }
        return returnNum;
      }

      prevButton.addEventListener( 'click', () => {
        resetIndex(thumbnailItem[calcCurrentIdx(slider.track.details.abs)]);
        slider.prev();
      });
      nextButton.addEventListener( 'click', () => {
        resetIndex(thumbnailItem[calcCurrentIdx(slider.track.details.abs)]);
        slider.next();
      });
      let distanceOfProgress = 0;
      const progressStart = e => {
        distanceOfProgress = slider.track.details.progress;
      }
      function progressEnd ()
      {
        if( distanceOfProgress === slider.track.details.progress
          && this.name !== calcCurrentIdx(slider.track.details.abs))
        {
          resetIndex(thumbnailItem[calcCurrentIdx(slider.track.details.abs)]);
          slider.moveToIdx(this.name);
        }
      }
      let timeout;
      let mouseOver = false;
      function clearSliderNextTimeout() {
        clearTimeout(timeout);
      }
      function sliderNextTimeout() {
        clearTimeout(timeout);
        if (mouseOver) return;
        timeout = setTimeout(() => {
          resetIndex(thumbnailItem[calcCurrentIdx(slider.track.details.abs)]);
          slider.next();
        }, 2000);
      }
      slider.slides.forEach((slide, i) => {
        slide.addEventListener('mousedown', progressStart,{passive:true});
        slide.addEventListener('touchstart', progressStart,{passive:true});
        slide.addEventListener('click', {name: i, handleEvent: progressEnd});
      });
      slider.on('dragged',()=>{
        slider.slides.forEach((slide, i) => {
          slide.style.cursor = 'grabbing';
        });
        resetIndex(thumbnailItem[calcCurrentIdx(slider.track.details.abs)]);
      });
      slider.on('dragEnded',()=>{
        slider.slides.forEach((slide, i) => {
          slide.style.cursor = '';
        });
      });
      slider.on('animationEnded',()=>{
        setIndex(thumbnailItem[calcCurrentIdx(slider.track.details.abs)]);
      });
      slider.on('created', () => {
        setIndex(thumbnailItem[0]);
      });
      slider.on("created", () => {
        slider.container.addEventListener("mouseover", () => {
          mouseOver = true;
          clearSliderNextTimeout();
        },{passive: true});
        slider.container.addEventListener("mouseout", () => {
          mouseOver = false;
          sliderNextTimeout();
        },{passive: true});
        sliderNextTimeout();
      });
      slider.on("dragStarted", clearSliderNextTimeout);
      slider.on("animationEnded", sliderNextTimeout);
      slider.on("updated", sliderNextTimeout);
    }

  }
});
